namespace GeniuzPOS.Inventory {
    export interface IcStockApproveDtForm {
        SkuCode: Serenity.LookupEditor;
        SkuDesc: Serenity.StringEditor;
        QtyOnhand: Serenity.DecimalEditor;
        QtyCount: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        QtyDif: Serenity.DecimalEditor;
        StkUnit: Serenity.StringEditor;
        CostValue: Serenity.DecimalEditor;
    }

    export class IcStockApproveDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockApproveDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockApproveDtForm.init)  {
                IcStockApproveDtForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(IcStockApproveDtForm, [
                    'SkuCode', w0,
                    'SkuDesc', w1,
                    'QtyOnhand', w2,
                    'QtyCount', w2,
                    'UnitCost', w2,
                    'QtyDif', w2,
                    'StkUnit', w1,
                    'CostValue', w2
                ]);
            }
        }
    }
}
